import * as React from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../../store";
import {Button} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save"
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab";
import { Tab } from '../Tab';
import { PopupDialog } from '../../core/components/PopupDialog';
import {t} from "../../core/localization";
// import {exampleFolderFields, exampleFolderFieldsDescriptor} from "./definitions/ExampleFolderFields";
import {EntityField} from "../../core/genericdocuments/EntityField";
import {FieldView} from "../components/FieldView";
import {Validator} from "../../core/Validator";
import {Utility} from "../../core/Utility";
import {CategoryDescriptor} from "../../models/Category";
import {Folder, FolderTypes} from "../../models/Folder";
import {actionFolderFetch, actionFolderSave} from "../../store/folders";
import {employeeFolderFieldsDescriptor} from "./definitions/EmployeeFolderFields";
import {actionDocumentFetch} from "../../store/documents";
import {DocumentTypes} from "../../models/Document";
import {employeeContractDocumentFieldsDescriptor} from "../documents/definitions/EmployeeContractDocumentFields";

export interface FolderTabProps extends BaseTabProps{
	tab: Tab
}

export interface FolderTabState extends BaseTabState{
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active
	};
}

class FolderTab extends BaseTab<FolderTabProps, FolderTabState> {

	constructor(props: FolderTabProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
	}

	componentDidMount() {
		if (this.props.item.id) actionFolderFetch(this.props.item)
	}

	componentWillMount() {
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderForm()}
				{this.renderControls()}
				{this.renderPopupDialog()}
			</div>
		);
	}

	renderForm(): React.ReactNode {

		let descriptor = this.getCreateFieldsDescriptor(this.props.item.type)
		return (<div className="create-form">
			{
				descriptor && descriptor.createFormFields.map(
					(entityField: EntityField<any>, index: number) => {
						const fieldName = entityField.name.toString()
						return (
							<div style={{ marginBottom: "0px" }}>
								<FieldView value={Utility.formatString(this.getGenericItemFromTabState(fieldName))}
										autoFocus={index === 0} field={entityField} formState={null}
										setFormState={null}
										validationState={null}
										handleInputChange={(fieldName, value) => this.handleGenericInputChange(fieldName, value)}
								/>
								{/*<FieldView autoFocus={index === 0} field={entityField} formState={formState} setFormState={Util.setFormStateWithHiddenFieldsDelete(p.entityFieldsDescriptor.createFormFields, setFormState)} validationState={validationState} /><FieldView autoFocus={index === 0} field={entityField} formState={formState} setFormState={Util.setFormStateWithHiddenFieldsDelete(p.entityFieldsDescriptor.createFormFields, setFormState)} validationState={validationState} />*/}
							</div>
						);
					}
				)
			}
		</div>)
	}

	renderControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse', marginTop: '10px'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	renderPopupDialog(): React.ReactNode {
		return <PopupDialog
			isOpen={this.state.isDialogOpen}
			title={this.state.dialogTitle}
			text={this.state.dialogText}
			onClose={this.onDialogClose.bind(this)}
		/>
	}

	onSaveClick () {
		let itemToSave = this.getGenericItemFromTabState()

		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, CategoryDescriptor)

		// creating save item
		let folder = new Folder()
		folder.id = this.props.item ? this.props.item.id : null
		folder.parentId = itemToSave.parentId
		folder.type = itemToSave.type
		folder.title = Folder.getTitle(folder)

		employeeFolderFieldsDescriptor.createFormFields.map((entityField: EntityField<any>, index: number) => {
			const fieldName = entityField.name.toString()
			if (Utility.isNullOrUndefined(itemToSave.fields) || Utility.isNullOrUndefined(itemToSave.fields[fieldName])) {
				if (!Utility.isNullOrUndefined(itemToSave[fieldName]))
					itemToSave.fields[fieldName] = itemToSave[fieldName]
			}
		})

		folder.fields = JSON.stringify(itemToSave.fields)

		if (validation.valid || true) {
			actionFolderSave(folder)
			// actionActiveTabTitle(t.Category + ': ' + this.getItemFromTabState('title'))
		}

		this.setState({ ...this.state, validation: validation });
	}

	getCreateFieldsDescriptor(type: FolderTypes) {
		switch (type) {
			case FolderTypes.Employee:
				return employeeFolderFieldsDescriptor
		}
		return null
	}
}

export default connect(mapStateToProps)(FolderTab);
